import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import * as Icons from "@mui/icons-material";
import { forwardRef } from "react";

// const GradientButton = withStyles({
//   root: {
//     background: "var(--theme-color1)",
//     border: 0,
//     color: "#fff !important",
//     fontWeight: 700,
//     minWidth: "80px",
//     letterSpacing: "0.02857em",
//     boxShadow: "none",
//     textTransform: "capitalize",
//     "&:hover": {
//       // background: "rgb(200,0,0)",
//       background: "var(--theme-color4)",
//       boxShadow: "none",
//     },
//     "&:active": {
//       background: "var(--theme-color4)",
//       boxShadow: "none",
//     },
//     //Commented By digal on 20/07/2023 for form button color disable after click
//     // "&:focus": {
//     //   background: "var(--theme-color4)",
//     //   boxShadow: "none",
//     // },
//   },
// })(Button);

interface AdditionalProps {
  starticon?: keyof typeof Icons;
  endicon?: keyof typeof Icons;
  rotateIcon?: string;
  textColor?: string;
  /**
   * Set false to remove box shadow
   * @default false
   */
  elevate?: boolean;
}

type GradientButtonProps = AdditionalProps & ButtonProps;

const StyledButton = styled(Button)(({}) => ({
  background: "var(--primary-bg)",
  color: "#fff",
  fontWeight: 700,
  minWidth: "80px",
  marginLeft: "5px",
  letterSpacing: "0.02857em",
  textTransform: "capitalize",
  transition: ".25s ease",
  // border: "1px solid var(--theme-color1)",
  "&:hover": {
    background: "var(--primary-bg)",
    opacity: "0.75",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
  },
  "&:disabled": {
    color: "#eee !important",
    opacity: "0.65 !important",
  },
}));

const GradientButton = forwardRef<HTMLButtonElement, GradientButtonProps>(
  (
    { starticon, endicon, rotateIcon, sx, textColor, elevate, ...other },
    ref,
  ) => {
    const StartIcon = starticon ? Icons[starticon] : null;
    const EndIcon = endicon ? Icons[endicon] : null;

    return (
      <StyledButton
        sx={{
          color: textColor,
          "&:hover": {
            "& .MuiSvgIcon-root": {
              transform: rotateIcon,
              transition: "transform 2s ease-in-out",
            },
          },
          boxShadow: elevate ? "2px 2px 4px rgba(0,0,0,.2)" : "none",
          ...sx,
        }}
        className="gradient-btn"
        ref={ref}
        startIcon={StartIcon ? <StartIcon /> : null}
        endIcon={EndIcon ? <EndIcon /> : null}
        {...other}
      />
    );
  },
);

export default GradientButton;
